// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".secret {\n  position: relative;\n  top: 5px;\n}\n.secret .v-messages {\n  display: none;\n}\n.alertText {\n  width: 100%;\n  -ms-word-break: break-all;\n  word-break: break-all;\n  word-break: break-word;\n  -ms-hyphens: auto;\n      hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n}", ""]);
// Exports
module.exports = exports;
